<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company showImage :data="companyData" :customData="details"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :data="details"/>
      </div>
      <div class="column">
        <Vendor :data="details"/>
      </div>
    </div>

    <Items class="block" :access="access" :items="details.Items"/>
    <template v-if="access.Fld_Amount">
      <Total class="block" :data="details" :items="details.Items" />
    </template>
  </kst-page-print-details>
</template>

<script>
import Model from "../PurModel.js";
import Services from "../../../services/Api/PurchaseServices.js"

import Details from "./PurPD_Details.vue";
import Vendor from "./PurPD_Vendor.vue";
import Items from "./PurPD_Items.vue";
import Total from "./PurPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Vendor,
    Items,
    Total,
    Company
  },
  data: () => ({
    access: {},
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.details = data.Details;
      this.companyData = data.CompanyDetails;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>